import "core-js/modules/es.array.push.js";
import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import { mapGetters } from 'vuex';
import cptCmn from '@/mixin/cpt-cmn';
import DataPickerCpt from '@/components/data-picker/DataPickerCpt';
import CodeDataPickerCpt from '@/components/data-picker/CodeDataPickerCpt';
import AttachmentCpt from '@/components/attachment';
import PopupDatePickerCpt from '@/components/date-time/PopupDatePickerCpt';
import { rqtGetCustomerAccount, rqtGetCustomerAdress } from '@/services/cms/customer';
import { rqtGetAppointmentDetail } from '@/services/wms/appointment';
import { rqtPostDefCodeList } from '@/services/common/defcode';
// import { rqtPostAttachmentList } from '@/services/common/attachment' 
import verificationCodeImg from '@/mixin/verification-code-img';
// import { resTol } from '@/tools/public'
import { rqtGetPlace } from '@/services/common/place';
// import { rqtPostListAgent } from '@/services/ams/agent'
import { rqtPostTradeSave, rqtPostTradeAudit, rqtGetTradeDetail } from '@/services/wms/trade';
import { showNotify } from 'vant';
export default {
  mixins: [cptCmn, verificationCodeImg],
  components: {
    PageNavBackLayoutCpt,
    AttachmentCpt,
    PopupDatePickerCpt,
    CodeDataPickerCpt,
    DataPickerCpt
  },
  data() {
    return {
      show: false,
      paymentAcc: undefined,
      appointmentId: undefined,
      fItemDataIndex: undefined,
      bankIndex: undefined,
      columnsFieldNames: {},
      paymentDate: undefined,
      lastTradeId: '99',
      lastAppointmentId: '88',
      attachFlag: '',
      //附件读写标志
      form: {
        //agentId: '',
        //customerId: '',
        //productId: '',
        //amount: '',
        //validateCode: '',
        tradeId: '',
        tradeNo: '',
        appointmentNo: '',
        appointmentId: '',
        subscriptionDate: '',
        entryDate: '',
        tradeWay: '',
        customerId: '',
        customerAccountId: '',
        customerAddressId: '',
        customerContactId: '',
        agentId: '',
        agentName: '',
        branchId: '',
        storeId: '',
        orderNo: '',
        tradeStatus: '15',
        auditStatus: '01',
        callBackStatus: '',
        confirmPrintStatus: '',
        transferTradeNo: '',
        transferDate: '',
        doubleAudio: '',
        productId: '',
        openDate: '',
        openDateOn: '',
        beneficialType: '',
        beneficialTypeText: '',
        beneficialTypeOn: '',
        subscriptionAmount: '',
        actualSubscriptionAmount: '',
        actualSubscriptionShare: '',
        currency: '',
        reductionRate: '',
        reductionRateOn: '',
        payTime: '',
        payTimeOn: '',
        bankName: '',
        bankBranchName: '',
        accountHolder: '',
        cardNo: '',
        pcc: '' // 省市区
      },

      btnLoading: false,
      attachmentType: '04',
      attachmentIds: [],
      codeResItems: [{
        title: '受益权类型',
        dataIndex: 'beneficialType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'beneficialType'
      }, {
        title: '性别',
        dataIndex: 'sex',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'sex'
      }, {
        title: '证件类型',
        dataIndex: 'idType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'idType'
      }]
    };
  },
  computed: {
    ...mapGetters('account', ['user'])
    // readonly() {
    //   return this.form.auditStatus && this.form.auditStatus != '01'
    // }
  },

  activated() {
    this.init();
  },
  methods: {
    init() {
      // let item = this.$route.query && this.$route.query.item
      // item = JSON.parse(item)
      let item = this.$route.params;
      this.form.appointmentId = item.appointmentId;
      //if(item.tradeId){
      this.form.tradeId = item.tradeId;
      //}
      //this.form.appointmentId = this.$route.query && this.$route.query.item.appointmentId
      //this.routeArg = this.$route.query && this.$route.query.item
      this.initResCodeType(this.codeResItems);
      // 从预约单进入，此时有appointmentId，无tradeId，从预约表里取数据
      if (item.appointmentId && !this.form.tradeId) {
        if (this.form.appointmentId === this.lastAppointmentId) {
          return;
        }
        if (this.form.appointmentId) {
          this.lastAppointmentId = this.form.appointmentId;
        }
        for (const fItem in this.form) {
          this.form[fItem] = '';
        }
        rqtGetAppointmentDetail(item.appointmentId).then(res => {
          const resData = res.data.data;
          for (const fItem in resData) {
            this.form[fItem] = resData[fItem];
          }
          // 获取agent 的 分公司和门店id
          // Promise.all([
          //   rqtGetDefCodeList({ codeType: 'beneficialType', code: resData.beneficialType })
          // ])
          //   .then(([res1]) => {
          //     const resData1 = res1.data.data
          //     this.form.beneficialTypeText = resData1.codeName
          //   }).catch(() => {})

          // for (const fItem in resData.wmsProductQueryRecordVO) {
          //   this.form[fItem] = resData.wmsProductQueryRecordVO[fItem]
          // }
          // for (const fItem in resData.appointment) {
          //   this.form[fItem] = resData.appointment[fItem]
          // }
          // for (const fItem in resData.customerBaseVo) {
          //   this.form[fItem] = resData.customerBaseVo[fItem]
          // }
          // this.form.appointmentId = resData.appointment.id
          // //this.form.mobile = resData.customerBaseVo.mobile
          // this.form.subscriptionAmount = resData.appointment.amount

          // 从预约过来的数据，清空账户和地址信息，让用户自己选择 
          this.form.accountHolder = '';
          this.form.bankBranchName = '';
          this.form.cardNo = '';
          this.form.street = '';
          this.form.id = '';
          this.form.auditStatus = '01';
          // this.initCustomerAccountForm()
          // this.initFitemAddrs()
        }).catch(() => {});
      }
      // 从交易单进入，有tradeid，从交易表里取数据
      if (item.tradeId) {
        //item = JSON.parse(item)
        // if(item.tradeId){
        //   this.form.tradeId = item.tradeId
        // }

        if (this.form.tradeId === this.lastTradeId) {
          return;
        }
        if (this.form.tradeId) {
          this.lastTradeId = this.form.tradeId;
        }
        for (const fItem in this.form) {
          this.form[fItem] = '';
        }
        rqtGetTradeDetail(item.tradeId, item.auditStatus).then(res => {
          const resData = res.data.data;
          for (const fItem in resData) {
            this.form[fItem] = resData[fItem];
          }
          if (resData.auditStatus === '01') {
            this.attachFlag = 'w';
          } else {
            this.attachFlag = 'r';
          }
          // 获取beneficialType
          Promise.all([rqtPostDefCodeList({
            code: resData.beneficialType,
            codeType: 'beneficialType'
          })]).then(([res1]) => {
            const resData1 = res1.data.data;
            this.form.beneficialTypeText = resData1[0].codeName;
          }).catch(() => {});
          // 银行信息包含在 resData 里了，不做处理
          // this.initCustomerAccountForm(resData.customerAccountId)
          this.initCustomerAddressForm(resData);
        }).catch(() => {});
      }
    },
    async initCustomerAddressForm(resData) {
      await Promise.all([rqtGetPlace({
        placeType: '01',
        placeCode: resData.province
      }), rqtGetPlace({
        placeType: '02',
        placeCode: resData.city
      }), rqtGetPlace({
        placeType: '03',
        placeCode: resData.country
      })]).then(([res1, res2, res3]) => {
        const resData1 = res1.data.data;
        const resData2 = res2.data.data;
        const resData3 = res3.data.data;
        this.form.pcc = [resData1.placeName, resData2.placeName, resData3.placeName].join();
      }).catch(() => {});
      if (!resData.street) {
        resData.street = '';
      }
      this.form.street = this.form.pcc + resData.street;
    },
    // initCustomerAccountForm(customerAccountId) {
    //   let that = this
    //   rqtGetCustomerAccountById(customerAccountId)
    //       .then(res => {
    //         const resData = res.data.data
    //         that.form.accountHolder = resData.accountHolder
    //       }).catch(() => {})
    //   // const selectFitems = this.bankResItems.filter(
    //   //   e => e.dataType === 'select' && !e.dataRes
    //   // )
    //   // for (const item of selectFitems) {
    //   //   switch (item.dataIndex) {
    //   //     case 'bankId':
    //   //       resTol.initReqResCb(
    //   //         item.dataRes,
    //   //         rqtGetCustomerAccount,
    //   //         params,
    //   //         res => {
    //   //           item.dataRes = res
    //   //           res.find(item => {
    //   //             that.form.bankInfo.forEach((curr, index) => {
    //   //               if (item.bankId == curr.bankId) {
    //   //                 that.form.bankInfo[index].bankName = item.bankName
    //   //               }
    //   //             })
    //   //           })
    //   //         }
    //   //       )
    //   //       break
    //   //   }
    //   // }
    // },

    // 查询地址
    onpickerDataSelectClickAdress(dataIndex) {
      this.fItemDataIndex = dataIndex;
      this.columnsFieldNames = {
        text: 'street',
        value: 'id'
      };
      let params = {
        customerId: this.form.customerId
      };
      this.$refs['DataPickerCpt'].showView('street', rqtGetCustomerAdress, params);
    },
    //查询银行
    onpickerDataSelectClickBank(dataIndex, index) {
      this.fItemDataIndex = dataIndex;
      this.bankIndex = index;
      this.columnsFieldNames = {
        text: 'bankNameAndCardNo',
        value: 'id'
      };
      let params = {
        customerId: this.form.customerId
      };
      this.$refs['DataPickerCpt'].showView('bankName', rqtGetCustomerAccount, params);
    },
    async onPickerDataSelected(selectedValues, selectedOptions) {
      // let index = this.bankIndex
      if (this.fItemDataIndex == 'bankId') {
        this.form.customerAccountId = selectedOptions[0].id;
        this.form.bankName = selectedOptions[0].bankName;
        this.form.bankBranchName = selectedOptions[0].bankBranchName;
        this.form.accountHolder = selectedOptions[0].accountHolder;
        this.form.cardNo = selectedOptions[0].cardNo;
      }
      if (this.fItemDataIndex == 'street') {
        this.form.customerAddressId = selectedOptions[0].id;
        await Promise.all([rqtGetPlace({
          placeType: '01',
          placeCode: selectedOptions[0].province
        }), rqtGetPlace({
          placeType: '02',
          placeCode: selectedOptions[0].city
        }), rqtGetPlace({
          placeType: '03',
          placeCode: selectedOptions[0].country
        })]).then(([res1, res2, res3]) => {
          const resData1 = res1.data.data;
          const resData2 = res2.data.data;
          const resData3 = res3.data.data;
          this.form.pcc = [resData1.placeName, resData2.placeName, resData3.placeName].join();
        }).catch(() => {});
        this.form.street = this.form.pcc + selectedOptions[0].street;
      }
    },
    onCodeDataPickerSelectClick(dataIndex, type, tag) {
      this.fItemDataIndex = dataIndex;
      this.$refs['CodeDataPickerCpt'].showView(type || dataIndex);
      if (tag) {
        this.fItemDataIndex = tag;
      }
    },
    onCodeDataPickerSelected(selectedValues, selectedOptions) {
      // let code = this.form[this.fItemDataIndex]
      this.form.beneficialTypeText = selectedOptions[0].codeName;
      this.form.beneficialType = selectedValues[0];
    },
    onPopupDateTimeSelectClick(dataIndex) {
      this.fItemDataIndex = dataIndex;
      this.$refs['PopupDateTimeCpt'].showView();
    },
    onDateTimeSelectedChange(val) {
      //this.subscriptionDate = val
      this.form[this.fItemDataIndex] = val;
    },
    //撤销
    onTradeInputCancle() {
      let params = {
        tradeId: this.form.tradeId,
        auditStatus: '09',
        tradeStatus: '09',
        workFlowNode: {
          workFlowId: '',
          status: '9',
          remark: ''
        }
      };
      this.btnLoading = true;
      rqtPostTradeAudit(params).then(() => {
        this.$message.success('撤销成功！');
        this.form.auditStatus = '09';
      }).catch(() => {
        this.btnLoading = false;
        this.$message.error('撤销失败！');
      });
    },
    //保存
    onSubmit() {
      this.form.currency = ' CNY';
      let data = new Date();
      let month = data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
      let date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
      this.form.entryDate = data.getFullYear() + "-" + month + "-" + date;
      this.form.actualSubscriptionAmount = this.form.subscriptionAmount;
      this.btnLoading = true;
      rqtPostTradeSave(this.form).then(res => {
        // let resData = res.data.data
        this.form.id = res.data.data.id;
        this.form.tradeId = res.data.data.id;
        this.form.tradeNo = res.data.data.tradeNo;
        this.lastTradeId = res.data.data.id;
        this.attachFlag = 'w';
        this.btnLoading = false;
        // this.onSaveClick = true
        // this.$message.success('保存成功！')
        // 设置这个，是因为从交易录入进入交易详情页面点击附件，返回的时候，tradeid是空
        this.$router.push({
          name: '交易详情',
          params: {
            tradeId: res.data.data.id
          }
        });
        showNotify({
          type: "success",
          message: "保存成功！"
        });
        // this.$emit('refreshTable')
        //直接跳转
        //this.$router.push('/work-wx/trade/record');
      }).catch(() => {
        this.btnLoading = false;
        showNotify({
          type: "success",
          message: "保存失败！"
        });
      });
    },
    // 提交复核
    onAuditSubmit() {
      let that = this;
      let params = {
        tradeId: that.form.tradeId,
        auditStatus: '02',
        workFlowNode: {
          status: '2'
        }
      };
      this.btnLoading = true;
      if (that.form.tradeId) {
        rqtPostTradeAudit(params).then(() => {
          this.btnLoading = false;
          this.$message.success('提交复核申请成功！');
          this.form.auditStatus = '02';
        }).catch(() => {
          this.btnLoading = false;
          this.$message.error('提交复核申请失败！');
        });
      } else {
        this.$message.error('请先点击保存按钮！');
      }
    }
  }
};